import React, { useEffect, useState, useMemo } from 'react';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { Card, CardBody, Row } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { Post_API_Conversations_Reservations } from '../../../../../constants/APIs';

export default function Reservations({ reservationIds }) {
  const ids = useMemo(
    () => (Array.isArray(reservationIds) ? reservationIds : []),
    [reservationIds?.join(',')]
  );
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!ids || ids.length === 0) {
      setReservations([]);
      return;
    }

    async function fetchReservations() {
      setLoading(true);
      setError(null);
      try {
        const res = await AxiosAPI({
          method: 'Post',
          url: Post_API_Conversations_Reservations,
          data: { reservationIds: ids },
        });

        const data = res.data;
        setReservations(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err?.message || 'Fetch error');
        setReservations([]);
      } finally {
        setLoading(false);
      }
    }

    fetchReservations();
  }, [ids]);

  const cardStyle = {
    width: '100%',
    borderRadius: 8,
    boxShadow: '0 4px 14px rgba(0,0,0,0.08)',
    border: '1px solid #eef2f7',
    marginTop: 16,
  };
  const scrollWrapperStyle = {
    maxHeight: '80vh',
    overflowY: 'auto',
    paddingRight: 8,
  };

  const cardBodyStyle = {
    padding: '20px 0',
  };

  const contentWrapperStyle = {
    maxWidth: 900,
    margin: '0 auto',
    padding: '0 24px',
  };

  const labelStyle = {
    fontSize: 12,
    color: '#6b7280',
    marginBottom: 4,
  };

  const valueStyle = {
    fontSize: 15,
    fontWeight: 600,
    color: '#111827',
  };

  function formatDate(d) {
    if (!d) return '-';
    try {
      const dt = new Date(d);
      return dt.toLocaleDateString();
    } catch {
      return d;
    }
  }

  return (
    <div>
      {loading && <p className="m-3">Loading reservations…</p>}
      {error && <p className="m-3" style={{ color: 'red' }}>Error: {error}</p>}

      {!loading && reservations && reservations.length > 0 ? (
        <Card
          className="scroll archive-card cardHeight"
          style={{
            overflowY: 'auto',
          }}
        >
          <Row className="m-3">
            {reservations.map((r) => (
              <Colxx xxs="12" className="p-0" key={r.id}>
                <Card className="mb-3">
                  <div className="my-3">
                    {/* Centered content with equal padding */}
                    <div style={contentWrapperStyle}>
                      {/* Guest */}
                      <Row className="mb-3">
                        <Colxx xxs="12">
                          <div style={labelStyle}>Guest</div>
                          <div style={{ ...valueStyle, fontSize: 17 }}>
                            {`${r.nameFirst || ''} ${r.nameLast || ''}`.trim() ||
                              '-'}
                          </div>
                        </Colxx>
                      </Row>

                      {/* Arrival / Departure */}
                      <Row className="mb-3">
                        <Colxx xxs="6">
                          <div style={labelStyle}>Arrival</div>
                          <div style={valueStyle}>
                            {formatDate(r.arrivalDate)}
                          </div>
                        </Colxx>
                        <Colxx xxs="6" className="text-right">
                          <div style={labelStyle}>Departure</div>
                          <div style={valueStyle}>
                            {formatDate(r.departureDate)}
                          </div>
                        </Colxx>
                      </Row>

                      {/* Adults / Children */}
                      <Row className="mb-3">
                        <Colxx xxs="6">
                          <div style={labelStyle}>Adults</div>
                          <div style={valueStyle}>
                            {r.numberOfAdults ?? '-'}
                          </div>
                        </Colxx>
                        <Colxx xxs="6" className="text-right">
                          <div style={labelStyle}>Children</div>
                          <div style={valueStyle}>
                            {r.numberOfChildren ?? '-'}
                          </div>
                        </Colxx>
                      </Row>

                      {/* Room */}
                      <Row>
                        <Colxx xxs="12">
                          <div style={labelStyle}>Room</div>
                          <div style={valueStyle}>{r.roomNumber || '-'}</div>
                        </Colxx>
                      </Row>
                    </div>
                  </div>
                </Card>
              </Colxx>
            ))}
          </Row>
        </Card>
      ) : (
        !loading && <p className="m-3">No reservations found</p>
      )}
    </div>
  );
}
